import { useEffect, useState } from 'react';

import api from './functions/api';

const apiBase = process.env.REACT_APP_API_URL;
const FALLBACK_NAME = 'บริษัท';

// ที่อยู่เป็นข้อความบรรทัดเดียว (รูปแบบเดียวกับที่ใบเสนอราคาใช้อยู่เดิม)
export function formatCompanyAddress(addr = {}) {
  return [
    addr.house_number,
    addr.village_number ? `หมู่ ${addr.village_number}` : '',
    addr.soi ? `ซอย${addr.soi}` : '',
    addr.road ? `ถนน${addr.road}` : '',
    addr.subdistrict ? `ตำบล${addr.subdistrict}` : '',
    addr.district ? `อำเภอ${addr.district}` : '',
    addr.province ? `จังหวัด${addr.province}` : '',
    addr.postcode,
  ].filter(Boolean).join(' ');
}

// cache แบบสั้นๆ กันยิงซ้ำตอนเปิดหลายหน้า/สร้าง PDF ติดกัน — หน้า "ข้อมูลบริษัท" เรียก invalidate หลังบันทึก
const CACHE_MS = 30 * 1000;
let cached = null;
let cachedAt = 0;

export function invalidateSaleCompany() {
  cached = null;
  cachedAt = 0;
}

// ดึงข้อมูลบริษัท — ล้มเหลว/ยังไม่เคยกรอก = {} (ผู้เรียกต้องรับมือกับค่าว่าง ไม่ใช่ error)
export async function fetchSaleCompany() {
  if (cached && Date.now() - cachedAt < CACHE_MS) {
    return cached;
  }
  try {
    const { data } = await api.get(`${apiBase}/sale-company`);
    cached = data || {};
    cachedAt = Date.now();

    return cached;
  } catch (error) {
    return {};
  }
}

// ชื่อบริษัทสำหรับแสดงผลในหน้าจอ (hook) — ระหว่างโหลด/ไม่มีข้อมูลจะเป็น fallback กลาง ไม่ใช่ชื่อบริษัทใดๆ
export function useSaleCompanyName() {
  const [name, setName] = useState('');

  useEffect(() => {
    let active = true;
    fetchSaleCompany().then((c) => active && setName(c.name || c.name_eng || ''));

    return () => { active = false; };
  }, []);

  return name || FALLBACK_NAME;
}

// ข้อมูลบริษัท + รูป (data URL) สำหรับสร้าง PDF — ไม่ throw; ข้อมูลที่ไม่มีเป็นสตริงว่าง
// PDF จึงเว้นส่วนนั้นไป ไม่ตกไปใช้ข้อมูลบริษัทอื่น
export async function loadSaleCompanyForPdf() {
  const company = await fetchSaleCompany();
  let images = {};
  try {
    const { data } = await api.get(`${apiBase}/sale-company/images`);
    images = data || {};
  } catch (error) {
    images = {};
  }

  return {
    nameTh: company.name || '',
    nameEn: company.name_eng || '',
    address: formatCompanyAddress(company.address),
    taxId: company.tax_id || '',
    phone: company.phone || '',
    tagline: company.tagline || '',
    logo: images.logo || null,
    seal: images.seal || null,
    signature: images.signature || null,
  };
}
